import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import CaseDiscussionPage from '../../components/CaseStudy/CaseDiscussionPage';

const CaseDiscussionPageRoute = () => (
  <ProtectedRoute requiresAuth={true}>
    <CaseDiscussionPage />
  </ProtectedRoute>
);

export default CaseDiscussionPageRoute;
